import { ACTION_TYPES } from '../../../constants';

const initialState = {
  message: ''
};

export const loginReducer = function (state = initialState, action) {
  switch (action.type) {
    case ACTION_TYPES.LOGIN.FAILURE:
      state = Object.assign({}, state, { message: action.payload.message });
      break;

    default:
      break;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/pages/login/components/loginForm/reducers/loginReducer.js